import { useSnapshot } from 'valtio';
import { useAssignMentorPrework } from './useAssignMentorPrework';
import { CandidatesBatchState } from '../CreateGroupPage/CandidatesList.store';
import { PreceptorsTable } from '../../../components/PreceptorsTable';
import { SNP_MODULE } from '../../../shared/Constants';

export const PreWorkAssignMentorContainer = () => {
	const {
		mentorsList,
		onMentorsPageChange,
		onMentorFilterChange,
		mentorsFilter,
		mentorPaging,
		onAssignMentorClick,
	} = useAssignMentorPrework();
	const preworkSelectedBatchID: number = JSON.parse(
		sessionStorage.getItem('preworkSelectedBatchID') || '0'
	) as number;
	const candidateBatchSnap = useSnapshot(CandidatesBatchState);
	const batchIdInSnap =
		candidateBatchSnap.selectedBatch?.id || preworkSelectedBatchID;

	return (
		<div className="p-8">
			<PreceptorsTable
				data={mentorsList}
				onPreceptorsPageChange={onMentorsPageChange}
				preceptorPageConfig={mentorPaging}
				preceptorsFilter={mentorsFilter}
				onPreceptorFilterChange={onMentorFilterChange}
				isMentorsTable={true}
				onAssignMentorClick={onAssignMentorClick}
				selectedBatchId={batchIdInSnap}
				selectedModule={SNP_MODULE.Prework}
			/>
		</div>
	);
};
